/* eslint-disable */
import { bus } from '../../../main';
var $ = window.jQuery = require('jquery');
import toast from '../../../services/toast';
export default {
  name: 'contest-quiz-section-create',
  components: {},
  props: [],
  data () {
    return {
      name:'',
      allocated_time:'',
      number_of_questions:'',
      index:'',
      submitted:false,
      is_active:true
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    sectionIsActiveStatusFun(){
      if(this.is_active == true){
        this.is_active = false
      }else{
        this.is_active = true
      }
    },
    createSectionsSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            quiz:this.$route.params.quizId,
            name: this.name,
            allocated_time: this.allocated_time,
            number_of_questions: this.number_of_questions,
            index:this.index,
            is_active:this.is_active
          }
          this.$store.dispatch('createdSectionForQuizFun', data)
          .then((res) => {
            this.name = '',
            this.allocated_time = '',
            this.number_of_questions = '',
            this.index = ''
            this.is_active = true
            toast.success(res.data.msg);
            this.$router.push({ name: 'contestQuizzesSectionConfig', params: { quizId: this.$route.params.quizId, quiz_sectionId:res.data.data.id } })
            this.$validator.reset();
            })
            .catch((err) => {})
          return
        }
      });
    },
  }
}


